import * as React from 'react';
import { NavLink } from 'react-router-dom';
import classes from './HeaderDropdown.module.css';

export interface HeaderDropdownItem {
  href: string;
  icon: React.ReactNode;
  title: React.ReactNode;
  subtitle: React.ReactNode;
}

interface HeaderDropdownProps {
  label: React.ReactNode;
  items: HeaderDropdownItem[];
  className?: string;
}

export const HeaderDropdown = ({ label, items, className }: HeaderDropdownProps): React.JSX.Element => {
  const detailsRef = React.useRef<HTMLDetailsElement>(null);
  const dropdownClassName = [classes.HeaderDropdown, className].filter(Boolean).join(' ');

  React.useEffect(() => {
    const handlePointerDown = (event: PointerEvent) => {
      const details = detailsRef.current;
      if (details?.open && !details.contains(event.target as Node)) {
        details.open = false;
      }
    };

    document.addEventListener('pointerdown', handlePointerDown);
    return () => document.removeEventListener('pointerdown', handlePointerDown);
  }, []);

  return (
    <details ref={detailsRef} className={dropdownClassName}>
      <summary className={classes.Trigger}>{label}</summary>
      <nav className={classes.Panel} aria-label={`${typeof label === 'string' ? label : 'Header'} menu`}>
        {items.map((item) => (
          <NavLink
            key={item.href}
            to={item.href}
            className={classes.Item}
            onClick={() => {
              const details = detailsRef.current;
              if (details?.open) {
                details.open = false;
              }
            }}
          >
            <span className={classes.Icon} aria-hidden="true">
              {item.icon}
            </span>
            <span className={classes.Copy}>
              <strong className={classes.Title}>{item.title}</strong>
              <span className={classes.Subtitle}>{item.subtitle}</span>
            </span>
          </NavLink>
        ))}
      </nav>
    </details>
  );
};
